import { render, staticRenderFns } from "./bar-picker.vue?vue&type=template&id=2511a5a9&scoped=true"
import script from "./bar-picker.vue?vue&type=script&lang=js"
export * from "./bar-picker.vue?vue&type=script&lang=js"
import style0 from "./bar-picker.vue?vue&type=style&index=0&id=2511a5a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511a5a9",
  null
  
)

export default component.exports